import * as React from "react";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ApplyModel } from "../../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { EWizardLinterStatus, WizardLinter } from "../../../../../../../Shared/Process/Process/WizardLinter";
import { SectionHeader, TrueFalseRadio } from "../../../../NewBusinessWizard/Components/SharedComponents";
import { EWizardLinterHelper } from "../../../Resource/EWizardLinterHelper";

interface IISASectionProps extends IProcessComponentProps {}

interface IISASectionState {}

export class ISASection extends ProcessComponent<IISASectionProps, IISASectionState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    getBlockStatus(data): EWizardLinterStatus {
        const complete = data?.IsAddRegularWithdrawalSelected != null;
        return EWizardLinterHelper.getEWizardLinterStatus(complete);
    }

    public render(): JSX.Element {
        const { data } = this.props;
        const productIndex = data.SelectedProducts.findIndex((e) => e.SubAccountType == SubAccountType.StocksIsa);
        const Product = data.SelectedProducts[productIndex];
        return (
            <WizardLinter
                status={this.getBlockStatus(Product)}
                enabled={EWizardLinterHelper.shouldDisplay(SubAccountType.StocksIsa)}
            >
                {SectionHeader("ISA options")}
                {TrueFalseRadio(
                    "Will your client be taking regular withdrawals?",
                    "IsAddRegularWithdrawalSelected",
                    Product,
                    (key, value) => {
                        this.onProductChange({ [key]: value }, Product, productIndex);
                    },
                    true,
                    { cssWrapper: "radio-group rg-inline rg-150 mb-16" }
                )}
                <hr className="mb-20" />
            </WizardLinter>
        );
    }

    private onProductChange(changes, product, index) {
        for (const key in changes) {
            product[key] = changes[key];
        }
        const data = this.props.data.SelectedProducts.concat();
        data[index] = product;
        this.props.onChange({
            SelectedProducts: data,
            IsaModel:
                changes?.IsAddRegularWithdrawalSelected == false
                    ? { ...(this.props.data as ApplyModel).IsaModel, RegularWithdrawalModel: [] }
                    : (this.props.data as ApplyModel).IsaModel,
        });
    }
}
